import { parseXMLSpriteSheets } from '../../parseClassicXMLSpritesheet';

export function parseSoundsData({
  gameData,
  gameAssetsFolder,
  commonAssetsFolder,
  language,
}) {
  let gameSounds = gameData.cards.reduce(
    (acc, card) => ({
      ...acc,
      [card.id]: {
        id: card.id,
        audio: `${gameAssetsFolder}/sounds/${card.id}.mp3`,
        volume: 1,
      },
    }),
    {}
  );
  const feedbackSoundIds = [
    'intro',
    'perfecto',
    'bien',
    'bravo',
    'muybien',
    'oo',
    'oooo',
  ];
  const languageFolder = language == 'es' ? '' : `${language}/`;
  const feedbackSounds = feedbackSoundIds.reduce((acc, soundId) => {
    return {
      ...acc,
      [soundId]: {
        id: soundId,
        audio: `${commonAssetsFolder}/sounds/${languageFolder}${soundId}.mp3`,
        volume: 1,
      },
    };
  }, {});
  gameSounds = { ...gameSounds, ...feedbackSounds };
  return gameSounds;
}

export async function parseClassicXMLSpriteSheets(gameData, gameAssetsFolder) {
  return parseXMLSpriteSheets(gameData, gameAssetsFolder);
}

export function parseImagesData(gameData, gameAssetsFolder) {
  return {
    cover: {
      id: 'cover',
      src: `${gameAssetsFolder}/img/${gameData.gameConf.cover}`,
    },
    menuBg: {
      id: 'menuBg',
      src:
        process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
        '/commonGameAssets/classic/menu_background.png',
    },
    cardFrontBg: {
      id: 'cardFrontBg',
      src:
        process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
        '/commonGameAssets/classic/memory/card-front-bg.png',
    },
    cardBackBg: {
      id: 'cardBackBg',
      src:
        process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
        '/commonGameAssets/classic/memory/card-back-bg.png',
    },
  };
}

export function parseActivityData(activityData, activityConf) {
  const gameConf = getCurrentLevelConf(activityData, activityConf);
  addTxtFromDragAndMatch(activityData, gameConf);
  return gameConf;
}

export function getCurrentLevelConf(activityData, activityConf) {
  const oldConf = activityData.gameConf.menu.buttons.find((button) =>
    button.id.toLowerCase().includes('cardmatch')
  );

  let currentLevelConf = null;
  if (oldConf.buttons) {
    const level = activityConf.level;
    currentLevelConf = oldConf.buttons.find((button) => {
      return button.buttonText.toLowerCase() == level.toLowerCase();
    });
    if (!currentLevelConf) {
      currentLevelConf = oldConf.buttons[0];
    }
  } else {
    currentLevelConf = oldConf;
  }

  return currentLevelConf.minigameConf;
}

function addTxtFromDragAndMatch(gameData, gameConf) {
  const oldConf = gameData.gameConf.menu.buttons.find((button) =>
    button.id.toLowerCase().includes('dragandmatch')
  );

  let txts = null;

  if (oldConf.buttons) {
    for (const button of oldConf.buttons) {
      txts = {
        ...txts,
        ...button.minigameConf.activityData.questions.txts,
      };
    }
  } else {
    txts = oldConf.minigameConf.activityData.questions.txts;
  }

  for (const card of gameConf.activityData.cards) {
    const txt = txts[card.id]?.text;
    if (txt?.includes('/')) {
      card.txt = txt.split('/').shift();
    } else if (txt?.includes('#')) {
      card.txt = txt.split('#').join(' ');
    } else {
      card.txt = txt;
    }
  }
}
